import type { SolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    gasSpecificGravity,
    oilAPI,
    temperatureF,
    reservoirPressurePSIA,
    inSituPressurePSIA,
    gasOilRatio
  } = params;
  // D64: =0.00091*D4-0.0125*D7
  const a = 0.00091 * temperatureF - 0.0125 * oilAPI;
  // D66: =D8*((D3/18.2+1.4)*10^(-D64))^1.204819
  const solutionGasRsoInSitu =
    gasSpecificGravity *
    ((inSituPressurePSIA / 18.2 + 1.4) * 10 ** -a) ** 1.204819;
  // D68: =D8*((D12/18.2+1.4)*10^(-D68))^1.204819
  const solutionGasRsoAtReservoir =
    gasSpecificGravity *
    ((reservoirPressurePSIA / 18.2 + 1.4) * 10 ** -a) ** 1.204819;

  return {
    a,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu
  };
};
